import { refreshToken as refreshTokenApi } from '../../../contexts/loginContexts';
import config from '../../../config';
import { getStoredAuthUser, storeAuthSession } from '../../../utils/authUser';

export const refreshAccessToken = async () => {
    try {
        const user = getStoredAuthUser();
        const refreshTokenValue = localStorage.getItem("refreshToken");

        if (!user || !refreshTokenValue) return false;

        const payload = {
            UserId: user.userId,
            RefreshToken: refreshTokenValue
        };

        const res = await refreshTokenApi(
            `${config.baseurl}Auth/refreshToken`,
            payload
        );

        if (res?.status !== 200 || !res?.data) return false;

        storeAuthSession(res.data);

        return true;
    } catch (error) {
        console.error("Refresh failed", error);
        return false;
    }
};
